@if ((announcementShelfPanel | async) === 'view') {
<onsip-adv-announcements-basic-view
  [announcement]="announcement"
  [transferToText]="transferToText"
  (editPanel)="togglePanel('edit')"
>
</onsip-adv-announcements-basic-view>
} @if ((announcementShelfPanel | async) === 'edit') {
<onsip-adv-announcements-basic-edit [announcement]="announcement" (viewPanel)="togglePanel('view')">
</onsip-adv-announcements-basic-edit>
}
